import React from "react";
import { Box } from "@mui/material";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { RelationshipTierCode } from "../models/models";
import { tierStyleMap } from "../utils/tierMaps";

interface TierBadgeProps {
  tier: RelationshipTierCode;
  size?: "small" | "medium";
  showIcon?: boolean;
}

const tierIcons: Record<RelationshipTierCode, React.ElementType> = {
  [RelationshipTierCode.Connected]: HandshakeOutlinedIcon,
  [RelationshipTierCode.Preferred]: StarOutlinedIcon,
  [RelationshipTierCode.Contracted]: DescriptionOutlinedIcon,
};

const TierBadge = ({ tier, size = "medium", showIcon = true }: TierBadgeProps) => {
  const style = tierStyleMap[tier];
  if (!style) return null;

  const isSmall = size === "small";
  const fontSize = isSmall ? "10px" : "11px";
  const iconSize = isSmall ? 12 : 14;
  const padding = isSmall ? "2px 7px" : "2px 8px";

  const IconComponent = tierIcons[tier] as React.ElementType;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding,
        borderRadius: "20px",
        fontSize,
        fontWeight: 600,
        letterSpacing: "0.02em",
        backgroundColor: style.bg,
        color: style.text,
        border: `1px solid ${style.text}22`,
        whiteSpace: "nowrap",
        fontFamily: 'var(--font-sans)',
        lineHeight: 1.4,
      }}
    >
      {showIcon && IconComponent && (
        <IconComponent sx={{ fontSize: iconSize }} />
      )}
      {style.label}
    </Box>
  );
};

export default TierBadge;
